module.exports = __webpack_public_path__ + "img/p_side.6027e434.png";